import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import cn from 'classnames';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import styles from './DecisionActDocument.module.scss';

interface IDecisionActDocumentProps {
  watchOnly: boolean;
  name: string;
  formRef: IDecisionFormRef | undefined;
  attachmentsNumber: number;
}

export const DecisionActDocument = memo(
  ({ watchOnly, name, attachmentsNumber, formRef }: IDecisionActDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={styles.ActDocument}>
        <div className="shared-group-label">
          Файл&nbsp;
          <span className="shared-no-wrap-text">
            акта
            <Button
              className={cn('shared-btn-add', styles.ActDocumentAddButton)}
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={watchOnly || attachmentsNumber > 0}
              onClick={openSignModal}
            />
          </span>
        </div>

        <KnmAttachmentsSigning
          isWatchOnly={watchOnly}
          name={name}
          formRef={formRef}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          acceptedFiles={'.doc,.docx,.odt,.xls,.xlsx,.ods,.pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip'}
        />
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const fieldError = props.errors?.organization?.act?.document?.attachments;
            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (errorMessage) {
              return <p className="shared-input-error shared-row__small-margin">{errorMessage}</p>;
            }

            return null;
          }}
        </FormSpy>
      </div>
    );
  },
);
